// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"fd7db009","648":"1f16b775"}[chunkId] + ".chunk.js";
};